export default __webpack_public_path__ + "static/media/icon-backarrow-grey.8c91c657.svg";